export interface IcTabClickEventDetail {
  tabId: string;
  contextId: string;
  position: number;
}

export interface IcTabSelectEventDetail {
  tabIndex: number;
  tabLabel: string;
}
